import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import func from "../../services/functions";
import selectStyle, { errorSelectStyle } from "../../design/selectStyle";
import mainAxios from "../../services/mainAxios";
import ReactDOM from 'react-dom';
import useClickOutside from "../../utils/useClickOutside";
import { useMemo } from "react";
import Loader from "../Layout/Loader";
import PopOver,{generalStyle} from "./PopOver";


const TaxPayerSearch = ({ onSelect, label,value,setValue, disabled,parseContent=true,showLabel=true,size="sm" }) => {
  const { t } = useTranslation("translations");
  const [inputClass, setInputClass] = useState("")
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0,width:0 });
  const selectRef = useRef();
  const [taxPayers,setTaxPayers] = useState([])

  const [selectedValue,setSelectedValue] = useState(null)
  let [inputValue,setInputValue] = useState(null)

  inputValue=value!=undefined?value:inputValue
  setInputValue=setValue!=undefined ? setValue:setInputValue

  const parseContentFn = (content=[]) =>{
    if(!parseContent) return content
    return content.map(taxPayer=>{
      let { name, town, address, country, tin } = taxPayer;
        name = name ? name.slice(0, 99) : null;
        town = town ? town.slice(0, 99) : null; 
        address = address ? address.slice(0, 200) : null;
        country = country ? func.getFullCountry(country,false) : null;
        return {name,town,address,country,tin}
    })
  }

  useClickOutside(selectRef, () => setMenuIsOpen(false));
  
  
  const fetchTaxPayers = async () => {
    const isNIPT = new RegExp("[a-zA-Z]{1}[0-9]{8}[a-zA-Z]{1}").test(inputValue);
    const content = isNIPT
      ? {
          object: "GetTaxpayersRequest",
          value:inputValue,
        }
      : {
          object: "GetTaxpayersRequest",
          params: { name: inputValue},
        }

      setInputClass("loading");
      return mainAxios.post("apiEndpoint/search", content).then((res) => {
        if (res?.data?.status === true) {
          if (res.data.content.length === 0) {
            toast.warning(t(["toast.noTaxPayer"]), {
              containerId: "all_toast",
            });
            setInputClass("error");
          } else {
            if(res.data.content.length==1){
              setMenuIsOpen(false);
              onSelect(parseContentFn(res.data?.content??[])[0])
            }else{
              setMenuIsOpen(true);
              setTaxPayers(parseContentFn(res.data.content))
            }
            setInputClass("success");
          }
        } else {
          setInputClass("error");
          return []
        }
      })
      .catch((e) => {
        setInputClass("error");
        return []
      });
  };

  const handleSearch = (e) => {
    if(e) e.preventDefault()
    if (disabled) return;
    fetchTaxPayers()
  };

  const handleSelectChange = (selected) => {
    setSelectedValue(selected)
    onSelect(selected || null);
    setMenuIsOpen(false)
  };
  const error= inputClass=="error"
  const buttonRef = useRef();


  useEffect(() => {
    if (buttonRef.current && menuIsOpen) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const dropdownHeight = 200;
      const viewportHeight = window.innerHeight;
  
      let top = buttonRect.bottom + window.scrollY;
      let left = buttonRect.left + window.scrollX;
      const buttonWidth = buttonRect.current?.clientWidth 
      if (top + dropdownHeight > viewportHeight) {
        top = buttonRect.top + window.scrollY - dropdownHeight; 
      }
  
      setMenuPosition({ top, left,buttonWidth });
    }
  }, [menuIsOpen]);


    const newSelectStyle = useMemo(() => {
    const buttonWidth = selectRef.current?.clientWidth 
    return {
      ...(error?{ ...selectStyle, control: errorSelectStyle.control }:selectStyle),
      container: (base) => ({
        ...base,
        width: buttonWidth,
      }),
      menu: (base) => ({
        ...base,
        marginTop: 0,
      }),
    };
  },[menuPosition.width]);
  
    
  return (
    <div style={{ position: 'relative',width:"100%", display: 'inline-block' }} ref={selectRef}>
      <div className="w-full" ref={buttonRef}>
            <div >
              {showLabel && (label?label: <label className="field-label mr-2 d-flex">
                {t("common.searchTaxPayers")}
                <PopOver title={t("common.niptOrBuName")} />
              </label>)}
              <form
                onSubmit={handleSearch}
              >
                <div className="input-group position-relative">
                  <input
                    name="seller"
                    type="text"
                    disabled={disabled}
                    className={
                      `form-control ${size=="sm"?"form-control-sm":""} required` +
                      (inputClass === "error"
                        ? " border-danger"
                        : inputClass === "success"
                        ? " border-success"
                        : "")
                    }
                    value={selectedValue?.name ?? (inputValue ?? "")}
                    onChange={(e) =>{
                      if(selectedValue!=null) setSelectedValue(null);
                      if (inputClass.length > 0) setInputClass("");

                      setInputValue(e.target.value)}}
                  />
                  <div className="input-group-append">
                    <span
                      className={`input-group-text cursor-pointer ${size=="sm"?"input-group-text-sm":""}`}
                      onClick={handleSearch}
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                  </div>
                  {inputClass === "loading" && (
                    <div className="input-icon input-loader">
                      <Loader size="xs" />
                    </div>
                  )}
                  {inputClass === "error" && (
                    <div className="input-icon text-danger">
                      <FontAwesomeIcon icon={faTimes} />
                    </div>
                  )}
                  {inputClass === "success" ? (
                    <div className="input-icon text-success">
                      <FontAwesomeIcon icon={faCheck} />
                    </div>
                  ) : null}
                </div>
              </form>
            </div>
      </div>

      {menuIsOpen && ReactDOM.createPortal(
        <div style={{
          position: "absolute",
          top: menuPosition.top,
          left: menuPosition.left,
          zIndex: 10001,
        }}>
          <Select
            value={taxPayers.find(opt=>opt.name==inputValue)}
            onChange={handleSelectChange}
            getOptionLabel={(opt)=>`${opt.name} - ${opt.tin}`}
            getOptionValue={(opt)=>opt.name}
            options={taxPayers}
            menuIsOpen={true}
            components={{ Control: () => null }}
            styles={newSelectStyle}
            isClearable
            isSearchable
          />
        </div>,
        document.getElementById("dropdown-container")
      )}
    </div>
  );

};

export default TaxPayerSearch;